import axios from 'axios';
import * as common from "@/utils/common";
import store from '@/store/index';

// import Login from '@/components/Login.vue';
// import License from '@/components/License.vue';
// import Template from '@/components/Template.vue';

const requireAuth = () => {
  return async (to, from, next) => {
    try {
      const response = await axios.get('/api/v1/' + "Login/CheckLogin", {});

      if (response && !response.data.error) {
        store.dispatch("login/CHECK_LOGIN", response);

        const { userData, sessionTimeout, loginResult } = response.data.list;
        if ("isAdmin" in userData) {
          sessionStorage.setItem("accessTime", common.nowEpoch());
          localStorage.setItem("loginUser", userData.userEmail);
          store.dispatch("user/SET_USER", { user: userData, sessionTimeout });
        }
        if (loginResult === 1 && userData) {
          next();
        } else {
          next("/login")
        }
      } else { next("/login") }
    } catch (error) {
      store.dispatch("login/CHECK_LOGIN", error);
      next("/login")
    }
  };
}

const dynamicModule = (x) => require(`@/components/routerComponents/${x}.vue`);
const router = (copyRoute, componentArray, module, index) => {
  var add = true;
  for (let i in copyRoute) {
    if (copyRoute[i].name === componentArray[0].toLowerCase()) {
      copyRoute[i].children = router(
        copyRoute[i].children,
        componentArray.slice(1),
        module,
        1
      );
      add = false;
    }
  }

  if (add) {
    var dict = {
      path:
        index === 0
          ? "/" + componentArray[0].toLowerCase()
          : componentArray[0].toLowerCase(),
      name: componentArray[0].toLowerCase(),
      component: module.default,
      beforeEnter:
        componentArray[0].toLowerCase() == "login" ? "" : requireAuth(),
      children: [],
    };
    if (module.redirectName && !!module.redirectName) {
      dict.children.push({
        path: "",
        name: componentArray[0].toLowerCase(),
        redirect: { name: module.redirectName },
      });
    }
    copyRoute.push(dict);
  }
  return copyRoute;
};

let basicRoutes = [
  {
    path: "/",
    redirect: { name: "login" },
  },
];

const req = require.context(
  "@/components/routerComponents",
  true,
  /^(?!.\/index).*.vue$/
);

req.keys().forEach((key) => {
  const component = key.substring(2).replace(".vue", "");
  const componentArray = component.split("/");
  // const module = dynamicModule(component)
  const module = dynamicModule(component);
  // console.log(module)
  basicRoutes = router(basicRoutes, componentArray, module, 0);
});
const routes = basicRoutes;

export default routes;

// const history = createWebHistory();
// const router = createRouter({
//   history,
//   routes: [
//     {
//       path: '/',
//       redirect: { name: 'login' }
//     },
//     {
//       path: '/login',
//       name: 'login',
//       component: Login
//     },
//     // {
//     //   path: '/main',
//     //   redirect: {name: "license"},
//     // },
//     {
//       path: '/license',
//       component: License,
//       name: 'licnese',
//       beforeEnter: requireAuth()
//     },
//     {
//       path: '/template',
//       component: Template,
//       name: 'template',
//       beforeEnter: requireAuth()
//     }
//   ]
// })

// export default router;